(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOWebapi", "VueDemi", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-price-guess/render"] = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGORender"));
	else
		root["/fego/component/common-price-guess/render"] = factory(root["FEGOWebapi"], root["VueDemi"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__55113__, __WEBPACK_EXTERNAL_MODULE__59906__, __WEBPACK_EXTERNAL_MODULE__85322__) => {
return 